export default function PHP_get_server_info() {
  return (
    <div>
      <h1>PHP_get_server_info</h1>
    </div>
  );
}
